exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ChangePasswordUser .v--modal-box.v--modal{min-height:200px!important;min-width:500px!important}#ChangePasswordUser .v-input__slot,#ChangePasswordUser .v-text-field__slot label{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-575e2859","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/userManagement/ChangePasswordUser.vue
// module id = 1965
// module chunks = 0